module.exports = __webpack_public_path__ + "img/look-up.77026c41.svg";